import React from 'react';
import TextTheme from "components/General/Text/TextTheme";


const ProfileDivider = (props) => {
	return (
    <div>
        {props.divider ? (
		<div className="child-form">
        <hr className="form-separator" />
      </div>
	):null}

	<div style={{textAlign:"center"}}>
      <TextTheme
      message={props.text}
      className="text_medium text_dark_orange text_semi_bold"
    />
    </div>
    <br/>
    </div>
)

};

export default ProfileDivider;